import { render, staticRenderFns } from "./questionBankManagement.vue?vue&type=template&id=d0b17556&scoped=true&"
import script from "./questionBankManagement.vue?vue&type=script&lang=js&"
export * from "./questionBankManagement.vue?vue&type=script&lang=js&"
import style0 from "./questionBankManagement.vue?vue&type=style&index=0&id=d0b17556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b17556",
  null
  
)

export default component.exports